import {t} from 'i18next';
import React from 'react';
import {useSelector} from 'react-redux';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import Button from '../../../../incase-domain/components/button/Button';
import {selectedSlideSelector} from '../../../../store/selectors/slide.selectors';
import {useSlideUpdateContext} from '../../../../ui/context/SetSlideUpdateContext';

function DeviceSelection(): JSX.Element {
    const {setSlide} = useSlideUpdateContext();

    const slide = useSelector(selectedSlideSelector);

    function getDeviceLabel(device: DeviceType): string {
        if (device === DeviceType.DESKTOP) {
            return t('presEditPage.subNavBar.desktop');
        }

        if (device === DeviceType.MOBILE) {
            return t('presEditPage.subNavBar.mobile');
        }

        return t('common.all');
    }

    return (
        <div className="c-toolbar__group">
            {[DeviceType.ALL, DeviceType.DESKTOP, DeviceType.MOBILE].map((device) => (
                <Button
                    key={device}
                    size="2xs"
                    fullWidth
                    color={
                        slide.deviceType === device || (slide.deviceType === undefined && device === DeviceType.ALL) ? 'secondary' : 'frost'
                    }
                    onClick={() => {
                        setSlide({...slide, deviceType: device});
                    }}
                >
                    {getDeviceLabel(device)}
                </Button>
            ))}
        </div>
    );
}

export default DeviceSelection;
